import { AloArboLg, getDefaultAloArboLg } from "./AloArboLg"
import { AloBase, getDefaultAloBase } from "./AloBase"
import { AloPlat } from "./AloPlat"


export interface AloArbo extends AloBase  {   
    image?:string 
    childrenIds?:Array<number>
    platsIds?:Array<number>
    isDefault?:boolean
    iconId?:number   
    lgs:Array<AloArboLg>
    tempsPreparation?:number
    heureDebut?:string
    heureFin?:string
}

export const getDefaultAloArbo = ():AloArbo => {
    return {
        ...getDefaultAloBase(),
        childrenIds:[],
        platsIds:[],
        isDefault:false,
        tempsPreparation:0,
        heureDebut:'00:00',
        heureFin:'23:59',
        lgs:[getDefaultAloArboLg()]
    }
}